<template>
  <div>
    <ul>
      <comment-item v-for="(item ,index) in listData" :key="index" :itemData="item"></comment-item>
    </ul>
  </div>

</template>

<script>
import CommentItem from './commentItem';
import { formatDateYMD } from '@utils';

export default {
  name: 'CommentList',
  props: {
    listData: {
      type: Array,
      default() {
        return [
          { name: '897' }
        ];
      },
    },
  },
  watch: {
    listData: {
      handler(n) {

        // console.log(n);
        n = n.map(item => {
          item.date = formatDateYMD(new Date(item.commentTime));
          item.tags = item.tags.split(',');
          return item;
        });
      },
      immediate: true,
    }
  },
  components: {
    CommentItem
  }
};
</script>

<style scoped>

</style>
